import {atom} from 'jotai'
import {
  VIPList,
  VIPCampaignList,
  VIPCampaignProductList,
  VIPCampaignProductListAll,
  VIPCampaignProductListAllItem,
} from '../domain'

const list: VIPList = {
  data: [],
  paging: {
    currentPageNumber: 1,
    totalPagesNumber: 0,
    pageSize: 10,
    totalCount: 0,
  },
  result: {
    isSuccess: false,
    errorMessage: null,
    errorCode: null,
  },
}

const vipCampaignList: VIPCampaignList = {
  data: [],
  paging: {
    currentPageNumber: 1,
    totalPagesNumber: 0,
    pageSize: 10,
    totalCount: 0,
  },
  result: {
    isSuccess: false,
    errorMessage: null,
    errorCode: null,
  },
}

const vipCampaignProductList: VIPCampaignProductList = {
  paging: {
    currentPageNumber: 1,
    totalPagesNumber: 0,
    pageSize: 10,
    totalCount: 0,
  },
  data: [],
  result: {
    customerMessage: null,
    errorCode: null,
    errorMessage: null,
    isSuccess: true,
  },
}

const vipCampaignProductListAll: VIPCampaignProductListAll = {
  paging: {
    currentPageNumber: 1,
    totalPagesNumber: 0,
    pageSize: 10,
    totalCount: 0,
  },
  data: [],
  result: {
    customerMessage: null,
    errorCode: null,
    errorMessage: null,
    isSuccess: true,
  },
}

export const VIPListAtom = atom<VIPList>(list)
export const VIPCampaignListAtom = atom<VIPCampaignList>(vipCampaignList)
export const VIPCampaignProductListAtom = atom<VIPCampaignProductList>(vipCampaignProductList)
export const vipCampaignProductListAllAtom =
  atom<VIPCampaignProductListAll>(vipCampaignProductListAll)

export const selectedGiveAwayProductAtom = atom<VIPCampaignProductListAllItem[]>([])
export const selectedCampaignProductAtom = atom<VIPCampaignProductListAllItem[]>([])

export const uploadType = atom<'products' | 'exclude' | null>(null)

export const campaignFiles = atom<{id: string; name: string; type?: number}[]>([])
export const uploadFileIds = atom<{id: string; name: string; type?: number}[]>([])
export const uploadProducts = atom<
  {id: string; code: string; name: string; category: string; createdOn: string; type?: number}[]
>([])

export const deleteFileIds = atom<string[]>([])
